import functions from '../../services/functions'
import site from '../../api/site'
import {
  GET_MYSITES_REQUEST,
  GET_MYSITES_SUCCESS,
  GET_MYSITES_FAILURE,
  GET_SITE_REQUEST,
  GET_SITE_SUCCESS,
  GET_SITE_FAILURE,
  GET_SITE_CAMERAS_REQUEST,
  GET_SITE_CAMERAS_SUCCESS,
  GET_SITE_CAMERAS_FAILURE,
  GET_CAMERA_SUCCESS,
  GET_SITE_MEMBERS_REQUEST,
  GET_SITE_MEMBERS_SUCCESS,
  GET_SITE_MEMBERS_FAILURE,
  GET_MEMBER_SUCCESS,
  GET_SITE_CONTACTS_REQUEST,
  GET_SITE_CONTACTS_SUCCESS,
  GET_SITE_CONTACTS_FAILURE,
  GET_CONTACT_SUCCESS
} from '../mutation-types'

// initial state
const state = {
  sites: {},
  status: {
    getMySites: null,
    getSite: {},
    getSiteCameras: {},
    getSiteMembers: {},
    getSiteContacts: {}
  }
}

// getters
const getters = {
  statusGetMySites: function (state) {
    return state.status.getMySites
  },
  mySites: function (state) {
    return state.sites
  },
  mySitesCount: function (state) {
    return Object.keys(state.sites).length
  },
  site: function (state, getters) {
    return function (siteId) {
      return getters.mySites[siteId]
    }
  }
}

// actions
const actions = {
  getSiteMembers: function ({commit, dispatch}, siteId) {
    return new Promise((resolve, reject) => {
      commit(GET_SITE_MEMBERS_REQUEST, {siteId: siteId})
      site.getSiteMembers(siteId).then(
        res => {
          if (res.body instanceof Array) {
            let members = []
            res.body.map(member => {
              if (member instanceof Object) {
                if (functions.hasAllKeys(member, [
                  'user_id',
                  'invitation_time',
                  'invitation_status',
                  'role',
                  'is_signedup',
                  'email',
                  'firstname',
                  'lastname',
                  'provider_picture'
                ])) {
                  members.push(member.user_id)
                  commit(GET_MEMBER_SUCCESS, {
                    userId: member.user_id,
                    memberSince: new Date(member.invitation_time).getTime(),
                    isMember: member.invitation_status === 2 ? 1 : 0,
                    isSignedUp: member.is_signedup,
                    role: member.role === 0 ? 'owner' : member.role === 1 ? 'admin' : member.role === 2 ? 'manager' : null,
                    email: member.email,
                    firstName: member.firstname,
                    lastName: member.lastname,
                    profilePictureUrl: member.provider_picture
                  })
                } else {
                  console.log('getSiteMembers failed')
                }
              }
            })
            commit(GET_SITE_MEMBERS_SUCCESS, {
              siteId: siteId,
              members: members
            })
            resolve()
          } else {
            commit(GET_SITE_MEMBERS_FAILURE, {siteId: siteId})
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
          dispatch('checkOnlineStatusByApiResponse', res)
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_SITE_MEMBERS_FAILURE, {siteId: siteId})
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  },
  getSiteContacts: function ({commit, dispatch}, siteId) {
    return new Promise((resolve, reject) => {
      commit(GET_SITE_CONTACTS_REQUEST, {siteId: siteId})
      site.getSiteContacts(siteId).then(
        res => {
          if (res.body instanceof Array) {
            let contacts = []
            res.body.map(contact => {
              if (contact instanceof Object) {
                if (functions.hasAllKeys(contact, [
                  'contact_id',
                  'created',
                  'email',
                  'is_verification_contact',
                  'name',
                  'phone',
                  'site_id',
                  'title'
                ])) {
                  contacts.push(contact.contact_id)
                  commit(GET_CONTACT_SUCCESS, {
                    contactId: contact.contact_id,
                    created: contact.created,
                    email: contact.email,
                    isVerificationContact: contact.is_verification_contact,
                    name: contact.name,
                    phone: contact.phone,
                    site_id: contact.site_id,
                    title: contact.title
                  })
                } else {
                  console.log('getSiteContacts failed')
                }
              }
            })
            commit(GET_SITE_CONTACTS_SUCCESS, {
              siteId: siteId,
              contacts: contacts
            })
            resolve()
          } else {
            commit(GET_SITE_CONTACTS_FAILURE, {siteId: siteId})
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
          dispatch('checkOnlineStatusByApiResponse', res)
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_SITE_CONTACTS_FAILURE, {siteId: siteId})
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  },
  getSiteCameras: function ({commit, dispatch}, siteId) {
    return new Promise((resolve, reject) => {
      commit(GET_SITE_CAMERAS_REQUEST, {siteId: siteId})
      site.getSiteCameras(siteId).then(
        res => {
          if (res.body instanceof Array) {
            let cameras = []
            res.body.map(camera => {
              if (camera instanceof Object) {
                if (functions.hasAllKeys(camera, [
                  'device_id',
                  'alarm_zone',
                  'trouble_zone',
                  'name',
                  'mac',
                  'type',
                  'channel',
                  'model',
                  'is_privacy',
                  'privacy_disabled_duration',
                  'privacy_disabled_timestamp',
                  'is_activated',
                  'is_online',
                  'is_online_update_time',
                  'is_cont_recording',
                  'firmware_update_status',
                  'is_registered',
                  'position_metadata',
                  'privacy_background_image_url',
                  'private_ip',
                  'public_ip',
                  'stream_url'
                ])) {
                  cameras.push(camera.device_id)
                  commit(GET_CAMERA_SUCCESS, {
                    siteId: siteId,
                    cameraId: camera.device_id,
                    alarmZone: camera.alarm_zone,
                    troubleZone: camera.trouble_zone,
                    name: camera.name,
                    mac: camera.mac,
                    type: camera.type,
                    channel: camera.channel,
                    model: camera.model,
                    isPrivacyEnabled: camera.is_privacy,
                    privacyDisabledDuration: camera.privacy_disabled_duration,
                    privacyDisabledTimestamp: camera.privacy_disabled_timestamp,
                    isActivated: camera.is_activated,
                    isOnline: camera.is_online,
                    isOnlineUpdatedAt: camera.is_online_update_time,
                    isContinuousRecordingEnabled: camera.is_cont_recording,
                    firmwareUpdateStatus: camera.firmware_update_status,
                    isRegistered: camera.is_registered,
                    positionMetadata: camera.position_metadata,
                    privacyBackgroundImageUrl: camera.privacy_background_image_url,
                    privateIp: camera.private_ip,
                    publicIp: camera.public_ip,
                    videoStreamUrl: camera.stream_url
                  })
                } else {
                  console.log('getSiteCameras failed')
                }
              }
            })
            commit(GET_SITE_CAMERAS_SUCCESS, {
              siteId: siteId,
              cameras: cameras
            })
            resolve()
          } else {
            commit(GET_SITE_CAMERAS_FAILURE, {siteId: siteId})
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
          dispatch('checkOnlineStatusByApiResponse', res)
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_SITE_CAMERAS_FAILURE, {siteId: siteId})
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  },
  getMySites: function ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      commit(GET_MYSITES_REQUEST)
      site.getMySites().then(
        res => {
          if (res.body instanceof Array) {
            res.body.map(site => {
              if (site instanceof Object) {
                if (functions.hasAllKeys(site, [
                  'site_id',
                  'dealer_id',
                  'customer_account_number',
                  'name',
                  'blueprint_url',
                  'address1',
                  'address2',
                  'lat',
                  'lng',
                  'timezone',
                  'owner_email',
                  'owner_firstname',
                  'owner_lastname',
                  'user_id'
                ])) {
                  commit(GET_SITE_SUCCESS, {
                    siteId: site.site_id,
                    dealerId: site.dealer_id,
                    customerAccountNumber: site.customer_account_number,
                    name: site.name,
                    blueprintUrl: site.blueprint_url,
                    address: site.address2 ? site.address2 + ' ' + site.address1 : site.address1,
                    address1: site.address1,
                    address2: site.address2,
                    lat: site.lat,
                    lng: site.lng,
                    timezone: site.timezone,
                    timezoneOffset: functions.getUtcOffset(site.timezone),
                    todayDateId: function () { return functions.getTodayBeginTimestamp(functions.getUtcOffset(site.timezone)) / 1000 },
                    todayBeginTimestamp: function () { return functions.getTodayBeginTimestamp(functions.getUtcOffset(site.timezone)) },
                    localTimeNow: function () { return new Date(functions.getNowTimestamp(functions.getUtcOffset(site.timezone))) },
                    convertToLocalTime: function (timestamp) { return new Date(functions.getLocalTimestamp(timestamp, functions.getUtcOffset(site.timezone))) },
                    primaryAdminEmail: site.owner_email,
                    primaryFirstName: site.owner_firstname,
                    primaryLastName: site.owner_lastname,
                    primaryAdminUserId: site.user_id
                  })
                } else {
                  console.log('getMySites failed')
                }
              }
            })
            commit(GET_MYSITES_SUCCESS)
            resolve()
          } else {
            commit(GET_MYSITES_FAILURE)
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
          dispatch('checkOnlineStatusByApiResponse', res)
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_MYSITES_FAILURE)
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  }
}

// mutations
const mutations = {
  [GET_MYSITES_REQUEST]: function (state, data) {
    state.status = {...state.status, getMySites: 'requested'}
  },
  [GET_MYSITES_SUCCESS]: function (state, data) {
    state.status = {...state.status, getMySites: 'successful'}
  },
  [GET_MYSITES_FAILURE]: function (state, data) {
    state.status = {...state.status, getMySites: 'failed'}
  },
  [GET_SITE_REQUEST]: function (state, data) {
    state.status.getSite = {...state.status.getSite, [data.siteId]: 'requested'}
  },
  [GET_SITE_SUCCESS]: function (state, data) {
    state.status.getSite = {...state.status.getSite, [data.siteId]: 'successful'}
    state.sites = {...state.sites, [data.siteId]: data}
  },
  [GET_SITE_FAILURE]: function (state, data) {
    state.status.getSite = {...state.status.getSite, [data.siteId]: 'failed'}
  },
  [GET_SITE_CAMERAS_REQUEST]: function (state, data) {
    state.status.getSiteCameras = {...state.status.getSiteCameras, [data.siteId]: 'requested'}
  },
  [GET_SITE_CAMERAS_SUCCESS]: function (state, data) {
    state.status.getSiteCameras = {...state.status.getSiteCameras, [data.siteId]: 'successful'}
    state.sites[data.siteId] = {...state.sites[data.siteId], cameras: data.cameras}
  },
  [GET_SITE_CAMERAS_FAILURE]: function (state, data) {
    state.status.getSiteCameras = {...state.status.getSiteCameras, [data.siteId]: 'failed'}
  },
  [GET_SITE_MEMBERS_REQUEST]: function (state, data) {
    state.status.getSiteMembers = {...state.status.getSiteMembers, [data.siteId]: 'requested'}
  },
  [GET_SITE_MEMBERS_SUCCESS]: function (state, data) {
    state.status.getSiteMembers = {...state.status.getSiteMembers, [data.siteId]: 'successful'}
    state.sites[data.siteId] = {...state.sites[data.siteId], members: data.members}
  },
  [GET_SITE_MEMBERS_FAILURE]: function (state, data) {
    state.status.getSiteMembers = {...state.status.getSiteMembers, [data.siteId]: 'failed'}
  },
  [GET_SITE_CONTACTS_REQUEST]: function (state, data) {
    state.status.getSiteContacts = {...state.status.getSiteContacts, [data.siteId]: 'requested'}
    state.sites[data.siteId] = {...state.sites[data.siteId], contacts: data.contacts}
  },
  [GET_SITE_CONTACTS_SUCCESS]: function (state, data) {
    state.status.getSiteContacts = {...state.status.getSiteContacts, [data.siteId]: 'successful'}
    state.sites[data.siteId] = {...state.sites[data.siteId], contacts: data.contacts}
  },
  [GET_SITE_CONTACTS_FAILURE]: function (state, data) {
    state.status.getSiteContacts = {...state.status.getSiteContacts, [data.siteId]: 'failed'}
    state.sites[data.siteId] = {...state.sites[data.siteId], contacts: data.contacts}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sites.js